<template>
    <div class="wanted_details">
        <div class="wanted_details_hea">
            <div class="wanted_cen">
                <div class="wanted_cen_log">
                    <img :src="$httpImg +'/img/logo_bal.png'" />
                    <span @click="goto('/wanted')">返回招聘列表</span>
                    <span @click="goto('/')">首页</span>
                </div>
                <span @click="goto('/user')">关于超拼网</span>

            </div>
        </div>
        <div class="wanted_cen">

            <div class="wanted_cen_left">
                <div class="wanted_cen_left_seach">
                    <el-input v-model="data.name" style="max-width: 600px" placeholder="输入职位关键词" class="input-with-select">
                        <template #prepend>
                            <el-button :icon="Search" />
                        </template>
                        <template #append>
                            <p style="color: #66CADB;font-size: 16px;cursor: pointer;" @click="getList">职位搜索</p>
                        </template>
                    </el-input>
                </div>
                <div class="wanted_seach_result">
                    <p>搜索到“ {{data.name}} ”关键词共“ {{ dataSce.total}} ”条招聘信息</p>
                    <div class="ul">
                        <div class="li" v-for="i in dataSce.values " :key="i"   @click="handleClick(index,i.id)">
                            <h6>{{ i.name }}</h6>
                            <div class="li_text">
                                <p>{{ i.company }}<span></span>{{ i.department }}<span></span>{{ i.fulltime }}<span></span>需求{{ i.number }}人</p>
                                <p>发布日期：{{ i.createTime }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wanted_cen_right">
                <h4  @click="goto('/wanted')">最新职位<span>更多 <el-button :icon="ArrowRight
                    " /></span></h4>
                <div class="ul">
                    <div class="li" v-for="i in data.list" :key="i" @click="getrichText(i.id)">
                        <h6>{{ i.name }}</h6>
                    </div>
                </div>


            </div>
        </div>
        <div class="wanted_foo">
            <p class="flex_center">{{ dataSce.numRecord }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img
                :src="$httpImg +'img/foo_icon.png'" /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ dataSce.recordPublic }}</p>
            <!-- <p class="flex_center">陕ICP备19006420号<img :src="$httpImg +'/img/foo_icon.png'" />陕网公安备：61110502000108号</p> -->
        </div>
    </div>
</template>

<script>
import { reactive,} from "@vue/reactivity";
import { onMounted } from "vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { Search } from '@element-plus/icons-vue'
import { useRouter, useRoute } from 'vue-router';
import { seachRecruitment,getrecruitment,getconfig } from '@/comm/api'
export default {
    setup() {
        const router = useRouter()
        const goto = (path, id) => {
            if (id) {
                router.push({ path: path, query: { id: id } })
            } else {
                router.push(path)
               
            }

        }
        const route = useRoute()
        let data = reactive({
            name: '',
            pageNo:1,
            pageSize:10

        });
        let dataSce = reactive({
            values:[],
            list:[],
            total:0,
        });
        const handleClick = (index, id) => {
            // data.activeIndex = index
            console.log(id,'111111111111')
            goto('/wanteddetails',id)
        }
        const getList = async () => {
            try {
                const res = await seachRecruitment({...data});
                if(res.code==1){
                    dataSce.values=res.data.records
                    dataSce.total = res.data.total
                }
            } catch (err) {
                console.error("失败", err);

            }
        };
        const getrichText = async () => {
            try {
                const res = await getrecruitment();
                if (res.code == 1) {
                    data.list = res.data
                }
            } catch (err) {
                console.error("失败", err);

            }
        };
        const getconfigFn = async (configName,) => {
            try {
                const res = await getconfig({ configName: configName });
                console.log(1, res);
                if (res.code == 1) {
                    dataSce[configName] = res.data
                }
            } catch (err) {
                console.error("失败", err);

            }
        };
        onMounted(()=>{
            data.name = route.query.name
            getList()
            getrichText()
            getconfigFn('recordPublic')
            getconfigFn('numRecord')
   
        })
        return {
            data,
            goto,
            Search,
            ArrowRight,
            route,
            dataSce,
            getList,
            getrichText,
            handleClick,
            getconfigFn,
        }
    }
}
</script>

<style lang="scss" scoped>
.wanted_details {
    background: #F2F2F2;

    .wanted_details_hea {
        background: #fff;
        height: 80px;
        line-height: 80px;

        span {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            margin-right: 20px;
        }

        .wanted_cen_log {
            width: 500px;
            display: flex;
            align-items: center;

            img {
                margin-right: 50px;
            }
        }
    }
}

.wanted_cen {
    width: 1200px;
    margin: 0 auto;
    display: flex;

    justify-content: space-between;

}

.wanted_cen_left {
    width: 70%;
    padding: 40px;
    margin-top: 40px;
    min-height: 500px;
    background: #fff;
    margin-bottom: 40px;

    .wanted_cen_left_seach {
        border: 1px solid #A3A5AC;
        border-radius: 30px;
        width: 350px;
        margin: 0 auto;
    }

    .wanted_seach_result {
        margin-top: 40px;

        .ul .li {
            padding-bottom: 20px;
            padding-top: 20px;
            border-bottom: 1px solid #CFCFCF;

            h6 {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 22px;
                color: #474B55;
            }


        }

        .li_text {
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            p {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #A3A5AC;

                span {
                    display: inline-block;
                    width: 1px;
                    height: 10px;
                    border-radius: 1px;
                    border-left: 2px solid #ABAAAA;
                    margin-left: 10px;
                    margin-right: 10px;
                }
            }
        }
    }

    .wanted_seach_result>P {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #A3A5AC;
        margin-bottom: 20px;
    }
}

.wanted_cen_right {
    width: 210px;
    height: max-content;
    background: #fff;
    margin-top: 40px;
    padding: 20px;

    h4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #474B55;

        span {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 11px;
            color: #6E727F;

            :deep(.el-button) {
                border: none;
                padding: 0px !important;
            }
        }
    }

    .ul .li {
        padding-bottom: 10px;
        padding-top: 10px;
        border-bottom: 1px solid #CFCFCF;

        h6 {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 15px;
            color: #474B55;
        }


    }
}

.wanted_foo {
    width: 100%;
    height: 48px;
    background: #1C1C1C;

    p {
        width: max-content;
        margin: 0 auto;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #747474;
    }
}

:deep(.el-input-group) {
    height: 40px;
    border-radius: 50px;
}

:deep(.el-input-group__prepend) {
    border-radius: 50px 0px 0px 50px;
    box-shadow: 0 0px 0px 0px var(--el-input-border-color, var(--el-border-color)) inset;
    background: transparent !important;
}

:deep(.el-input-group__append) {
    border-radius: 50px;
    background: #66CADB !important;
    box-shadow: 0 0px 0px 0px var(--el-input-border-color, var(--el-border-color)) inset;
    width: 100px;

}

:deep(.el-input-group__append > p) {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 14px;
    color: #fff !important;
}

:deep(.el-input-group--append > .el-input__wrapper) {
    background: transparent !important;
    color: #fff;
    box-shadow: 0 0px 0px 0px var(--el-input-border-color, var(--el-border-color)) inset;
    cursor: text;
}

:deep(.el-input__inner) {
    color: #A3A5AC !important;
}

:deep(.el-icon svg) {
    color: #A3A5AC !important;
}
.flex_center{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>